import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import router from '@/router';
import { getToken } from '@/utils/auth';
import { getAccount } from '@/utils/account';
import store from '@/store';
import { checkVersion } from '@/utils/versionUpdate';
import { sendWebSlsTrackingData } from '@/utils/slsTracking';

NProgress.configure({ showSpinner: true });

const hasRoute = (url) => {
  const { authList, menus } = store.state.menu;
  let temp = [...authList, ...menus];
  let cur = temp.shift();
  while (cur) {
    if (cur.children) {
      temp = temp.concat(cur.children);
    }
    if (cur.url === url) {
      return true;
    }
    cur = temp.shift();
  }
  return false;
};

const getRouteUrl = (route) => {
  const {
    path,
    params,
  } = route;
  let url = path;
  Object.keys(params).forEach((key) => {
    const val = params[key];
    url = url.replace(new RegExp(val), key);
  });

  return url;
};

/* eslint-disable no-lonely-if */
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  // 判断当前代码版本是否与代码版本一致，如不一致则刷新页面获取最新
  checkVersion();
  if (getToken()) {
    // Has logged in
    // 判断是否需要获取菜单
    if (!store.state.menu.isGetMenu && to.fullPath !== '/LOGIN') {
      await store.dispatch('menu/getMenus');
    }

    // 处理用户信息为空 跳转登录页面重新登录
    if (!getAccount()) {
      if (to.path === '/login' || to.path === '/forgotPwd') {
        next();
        NProgress.done();
      } else {
        const redirectUrl = encodeURIComponent(to.path);
        next({ path: `/login?redirect=${redirectUrl}`, replace: true });
        NProgress.done();
      }
    } else if (to.path === '/login') {
      next('/');
      NProgress.done();
    } else {
      if (to.matched.length === 0) {
        // Not match router
        next({ path: '/redirect/404', replace: true });
      } else {
        if (!to.meta.auth) {
          next();
        } else {
          const url = getRouteUrl(to);
          if (hasRoute(url)) {
            next();
          } else {
            if (store.state.menu.workPermission && to.path === '/dashboard') {
              next({
                path: '/home',
                replace: true,
              });
            } else {
              next({ path: '/redirect/403' });
            }
          }
        }
      }
    }
  } else {
    // Not logged in
    if (to.matched.length === 0) {
      console.warn('no match router');
      next({ path: '/login', replace: true });
      NProgress.done();
    } else {
      // match router
      if (to.meta.auth) {
        const redirectUrl = encodeURIComponent(to.fullPath);
        next({ path: `/login?redirect=${redirectUrl}`, replace: true });
        NProgress.done();
      } else {
        next();
      }
    }
  }
});

router.afterEach((to) => {
  NProgress.done();

  const { meta } = to;
  if (meta.trackCode) {
    sendWebSlsTrackingData({ name: meta.trackName || '', code: meta.trackCode });
  }
});
